import TicketDetailController from './ticket.detail.controller';

export default {
    bindings: { ticketFromPreFa: '=' },
    template: require('./ticket.detail.html'),
    controller: TicketDetailController
};
